// 管家相关接口
import request from '@/utils/request'

/**
 *
 * @param params
 * @param data
 * @returns {*}
 */
/*export function housekeeperPage(params,data) {
    return request({
        url: '/housekeepers/page',
        method: 'post',
        params,
        data
    })
}*/
/**
 *
 * @param params
 * @returns {*}
 */
export function housekeeperPage(params) {
    return request({
        url: '/housekeepers/page',
        method: 'get',
        params
    })
}
/**
 * 添加明星管家
 * @param data
 * @returns {*}
 */
export function housekeeperAdd(data) {
    return request({
        url: '/housekeepers',
        method: 'post',
        data
    })
}
/**
 * 编辑明星管家
 * @param data
 * @returns {*}
 */
export function housekeeperEdit(data) {
    return request({
        url: '/housekeepers',
        method: 'put',
        data
    })
}
/**
 * 设置为明星
 * @returns {*}
 */
export function housekeeperStar(id) {
    return request({
        url: '/housekeepers/start/'+id,
        method: 'put'
    })
}
/**
 * 删除某个管家
 * @param id
 * @returns {*}
 */
export function housekeeperRemove(id) {
    return request({
        url: '/housekeepers/'+id,
        method: 'delete'
    })
}
